<div [class.empty-state__icon-wrapper]="hasIcon">
  <ng-content select="mat-icon"></ng-content>
</div>
<div class="empty-state__content">
  <h1 class="empty-state__title mat-headline-5">{{ title }}</h1>
  @if (subtitle) {
    <p class="empty-state__subtitle mat-subtitle-2">
      {{ subtitle }}
    </p>
  }
  <ng-content></ng-content>
</div>
